export const formatAppsyncErrors = error => {
  const { message } = error || {}
  const formattedMsg = message ? message.replace('GraphQL error:', '').trim() : null
  return error ? formattedMsg || 'Please try again.' : null
}

export const getQueryDataWithoutKey = data => data && Object.values(data)[0]
